import { useId } from "react";
import type { ModalBackdropConfig } from "@/contexts/layout/modal-stack-types";
import { useRegisterModal } from "@/contexts/layout/use-register-modal";

const CRISINGMODAL_REGISTRATION_ID = "crisingmodal";

interface CrisingmodalRegistrationInput {
  handleBack: () => void;
  risingBackdrop: ModalBackdropConfig;
  visible: boolean;
}

export function useCrisingmodalRegistration({
  handleBack,
  risingBackdrop,
  visible,
}: CrisingmodalRegistrationInput): ReturnType<typeof useRegisterModal> {
  const modalRegistrationId = useId();

  return useRegisterModal({
    id: `${CRISINGMODAL_REGISTRATION_ID}-${modalRegistrationId}`,
    visible,
    onClose: handleBack,
    backdrop: risingBackdrop,
    holdUntilExitComplete: true,
  });
}
